
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import WaterQualityChlorinePagePopup from './WaterQualityChlorinePopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import moment from 'moment'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Loading } from '../../../../../../Helper/Loading'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { WaterSupplyLocationDataDDL } from '../../../../../../Components/CommonDDL/WaterSupplyLocationDataDDL'
import { ChlorineDeleteAPI, ChlorinePDFReportTableDataAPI, ChlorineTableDataAPI, ChlorineTableExportDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWaterQualitySlice/ChlorineSlice'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL'
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL'
import { WaterQualityChlorineServiceExportData } from './WaterQualityChlorineServiceExportPage'
import { TableNote } from '../../../../../../Components/Note/Note'
import { toastErrorr } from '../../../../../../Helper/ToastMessage'
import { WaterChlorineExport } from './WaterChlorineExport'
import WaterQualityChlorineServiceGrid from './WaterQualityChlorineServiceGrid'

export default function WaterQualityChlorineServicePage() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [WaterQualityPhPopupShow, setWaterQualityPhPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [WaterQualityChlorinePopupShow, setWaterQualityChlorinePopupShow] = useState()

    // const [WardName, setWardName] = useState({
    //     DDL: [],
    //     ID: HWard && HWard ? HWard : RoleID == '16' ? WardName.ID : '0',
    //     Label: WLable && WLable ? WLable : RoleID == '16' ? WardName.Label : "Select...",
    // })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: RoleID == '16' ? 0 : HWard && HWard ? HWard : '0',
        Label: RoleID == '16' ? "Select..." : WLable && WLable ? WLable : "Select...",
    })
    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    const handleEditOnClick = (item) => {
        setWaterQualityChlorinePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterQualityChlorinePopupShow(false)
    }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: RoleID == '16' ? 0 : HWard,
            Label: RoleID == '16' ? 'Select...' : WLable,
        })
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))

        // console.log("call")
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    const handleGetPDFUrl = (pdfUrl) => {
        // console.log('pdfUrl',pdfUrl)
        if (pdfUrl && pdfUrl != '') {
            window.open(pdfUrl)
            // setPDFUrl(pdfUrl)
        }
        //  else {
        //     toastErrorr("PDF not found")
        // }
    }

    // const handleGetPDF = () => {
    //     const data = {
    //         FromDate: FromDate,
    //         ToDate: ToDate,
    //         M_WardID: WardName.ID,
    //         M_WS_JunctionID: JunctionNameDDL.ID,
    //         M_UserID: UserID,
    //         token: token,
    //         From: From,
    //         To: To,
    //         DashProjectTypeId: DashProjectTypeId,
    //         RoleID: RoleID,
    //         Flag: 'Report',
    //         handleGetPDFUrl: handleGetPDFUrl
    //     }

    //     dispatch(ChlorinePDFReportTableDataAPI({ data }))
    // }

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            M_UserID: UserID,
            Flag: 'Grid',
            token: token,
            From: From,
            To: To,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            handleWaterSupplyChlorineExport: handleWaterSupplyChlorineExport
        }
        // if (WardName.ID !== 0) {
        dispatch(ChlorineTableDataAPI({ data }))
        // }

    }, [IsPost, From, To, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.ChlorineTableData)

    const handleWaterSupplyChlorineExport = () => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            M_UserID: UserID,
            Flag: 'Report',
            token: token,
            From: '1',
            To: '99999',
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            // handleGetPDFUrl: handleGetPDFUrl
        }
        // if (WardName.ID !== 0) {
        dispatch(ChlorineTableExportDataAPI({ data }))
        // }
    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.ChlorineTableExportData)



    const handleDeleteApi = (item) => {
        const data = {
            T_WS_WaterQualityChlorineID: item.t_wS_WaterQualityChlorineID,
            T_Distri_WaterQualityChlorineID: item.t_Distri_WaterQualityChlorineID,
            M_UserID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            handleIsPost: handleIsPost,
            RoleID: RoleID
        }
        dispatch(ChlorineDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.ChlorineDeleteData)

    const [OpenGridPopUp, setOpenGridPopUp] = useState(false)

    const handleOpenGrid = () => {
        setOpenGridPopUp(!OpenGridPopUp)
    }

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-8'>
                                <h5 className="mt-2">Water Quality-Chlorine</h5>
                            </div>
                            <div className='col-4 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <>
                                                {
                                                    RoleID != 16 ?
                                                        <WaterChlorineExport
                                                            ExcelData={ExportTableData}
                                                            FromDate={FromDate}
                                                            ToDate={ToDate}
                                                            name='Water Quality-Chlorine'
                                                            RoleID={RoleID}
                                                            WardName={WardName}
                                                        />
                                                        :
                                                        <WaterQualityChlorineServiceExportData
                                                            ExcelData={ExportTableData}
                                                            FromDate={FromDate}
                                                            ToDate={ToDate}
                                                            name='Water Quality-Chlorine'
                                                            RoleID={RoleID}
                                                            WardName={WardName}
                                                        // searchName={searchName}
                                                        />
                                                }
                                            </>
                                    }
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-12 col-md-4 col-lg-2 ">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={FromDate}
                                                        onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 col-lg-2 ">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={ToDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                        min={FromDate}
                                                    />

                                                </div>
                                            </div>
                                            {/* {
                                                RoleID == '16' ?
                                                    <>
                                                        <div className="col-lg-2 col-md-4">
                                                            <WardNameDataDDL
                                                                WardName={WardName}
                                                                setWardName={setWardName}
                                                            // HWard={HWard}
                                                            // WLable={WLable}
                                                            // Flag='ward'
                                                            />
                                                        </div>
                                                    </>
                                                    :  */}
                                            <div className="col-lg-2 col-md-4">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                // Flag='ward'
                                                />
                                            </div>
                                            {/* } */}
                                            {
                                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                                    <>
                                                        <div className="col-lg-3 col-md-4">
                                                            <DistributionLineLocationDataDDL
                                                                DistributionLineLocationDDL={JunctionNameDDL}
                                                                setDistributionLineLocationDDL={setJunctionNameDDL}
                                                                WardName={WardName}
                                                            // Flag='ward'
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="col-lg-3 col-md-4">
                                                        <JunctionNameDataDDL
                                                            JunctionNameDDL={JunctionNameDDL}
                                                            setJunctionNameDDL={setJunctionNameDDL}
                                                            WardName={WardName}
                                                        />

                                                    </div>
                                            }
                                            <div className="col-12 col-lg-2 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary "
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger mx-2"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>


                                                {
                                                    tableData && tableData.table && tableData.table.length > 0 &&
                                                    <>
                                                        {
                                                            RoleID == 16 &&
                                                            <button type="button"
                                                                disabled={isExportLoading}
                                                                className="btn-View btn btn-primary px-3"
                                                                onClick={() => handleOpenGrid()}
                                                            >
                                                                {
                                                                    isExportLoading ?
                                                                        <>
                                                                            <i
                                                                                className="fa fa-refresh fa-spin"
                                                                                style={{ marginRight: "5px" }}
                                                                            />
                                                                        </>
                                                                        : 'View'}
                                                            </button>
                                                        }
                                                    </>
                                                }
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive">
                                            <TableNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Date</th>
                                                        <th>Time</th>
                                                        <th>Ward Name</th>
                                                        {
                                                            (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                <th>Location</th>
                                                                :
                                                                <th>Junction</th>
                                                        }
                                                        <th>Inlet</th>
                                                        <th>Outlet</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>

                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                <td>{item.readingTime ? item.readingTime : '-'}</td>
                                                                <td>{item.wardName ? item.wardName : '-'}</td>
                                                                {
                                                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                        <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                                        :
                                                                        <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                                                }
                                                                <td>{item.inletChlorine ? (item.inletChlorine).toFixed(2) : '0.00'}</td>
                                                                <td>{item.outChlorine ? (item.outChlorine).toFixed(2) : '0.00'}</td>
                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    {
                                                                        (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                            <>
                                                                                <span >

                                                                                    <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => handleEditOnClick(item)}
                                                                                    >
                                                                                    </i>
                                                                                </span>
                                                                                <span>
                                                                                    <DeletePopup
                                                                                        open={DeletePopupShow}
                                                                                        handleDeleteApi={handleDeleteApi}
                                                                                        item={item}
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    WaterQualityChlorinePopupShow ?
                        <WaterQualityChlorinePagePopup
                            open={WaterQualityChlorinePopupShow}
                            // popupHeading="Water Quality-Chlorine"                        
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashProjectTypeId={DashProjectTypeId}
                            RoleID={RoleID}
                        />
                        : <></>
                }

                {
                    OpenGridPopUp &&
                    <WaterQualityChlorineServiceGrid
                        open={OpenGridPopUp}
                        handleOnCloseClick={handleOpenGrid}
                        ExcelData={ExportTableData}
                        WardName={WardName}
                        JunctionNameDDL={JunctionNameDDL}
                        FromDate={FromDate}
                        ToDate={ToDate}
                    />
                }
            </div>
        </div>



    )
}